module.exports = __webpack_public_path__ + "static/media/error-general.aa8160d6.png";